import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, NgIf, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { ValidationService } from '../../services/validation.service';
import { ScriptService } from '../../services/script.service';
import { ToggleTabsComponent } from '../../components/toggle-tabs/toggle-tabs.component';
import { AssessmentService } from '../../services/assessment.service';
import { EvaluationService } from '../../services/evaluation.service';
import { ReEvaluationService } from '../../services/re-evaluation.service';
import { DropdownService } from '../../services/dropdown.service';
import { GetEvaluationMarksPipe } from '../../pipes/get-evaluation-marks.pipe';
import { GracePeriodCountdownComponent } from '../../components/grace-period-countdown/grace-period-countdown.component';

@Component({
  selector: 'app-script-list-page',
  imports: [HeaderComponent, ButtonComponent, NgIf, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, FormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, ToggleTabsComponent, SelectInputComponent, GetEvaluationMarksPipe, DatePipe],
  providers: [DatePipe],
  templateUrl: './script-list-page.component.html',
  styleUrl: './script-list-page.component.css'
})
export class ScriptListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Script';
  evaluation: any = 'Start'
  evaluation_id: any
  form: FormGroup;
  params: any = {};
  selected_item: any = {};
  items: any;
  script: any;
  header_details: any = {}
  is_grace_period_active = false;

  columns: any = [];

  actions(row: any) {
    let actions: any = []

    // Check if Re-Check button should be shown based on grace period
    const showRecheckButton = this.isWithinGracePeriod(row);
    if (this.header_details.type == 'Auto') {
      if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        // For head evaluators
        if (this.current_status_filter === 'Checked' || this.current_status_filter === 'Completed') {
          // For Checked/Completed status, always show View button; Re-Check if within grace period
          if (showRecheckButton) {
            actions.push({ type: 'button', text: 'Re-Check', function: this.recheckHeadEvaluation.bind(this) })
          }
          actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
        } else if (this.current_status_filter === 'Pending') {
          if (this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
            actions.push({ type: 'button', text: 'Check', function: this.check.bind(this) })
          } else {
            actions.push({ type: 'button', text: 'Evaluate', function: this.check.bind(this) })
          }
        } else if (this.current_status_filter === 'In Progress') {
          actions.push({ type: 'button', text: 'Resume', function: this.check.bind(this) })
        }
      }
      // For regular evaluators
      else {
        // In Auto re-eval mode, scripts are assigned per-row (not picked from a random
        // pool), so the per-row Check/Resume button must drive the flow — the header
        // "Start Evaluation" button is hidden in re-eval mode.
        if (this.is_re_evaluation_mode) {
          if (this.current_status_filter === 'Pending') {
            actions.push({ type: 'button', text: 'Re-Evaluate', function: this.manual_check.bind(this) })
          } else if (this.current_status_filter === 'In Progress') {
            actions.push({ type: 'button', text: 'Resume', function: this.recheck.bind(this) })
          } else {
            if (showRecheckButton) {
              actions.push({ type: 'button', text: 'Re-Check', function: this.recheck.bind(this) })
            }
            actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
          }
        } else {
          if (showRecheckButton) {
            actions.push({ type: 'button', text: 'Re-Check', function: this.recheck.bind(this) })
          }
          actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
        }
      }
    } else if (this.header_details.type?.toLowerCase() == 'manual') {
      if (this.current_status_filter === 'Checked' || this.current_status_filter === 'Completed') {
        // Show Re-Check only if still within grace period
        if (showRecheckButton) {
          actions.push({ type: 'button', text: 'Re-Check', function: this.recheck.bind(this) })
        } else {
          actions.push({ type: 'text', text: 'Submitted', disabled: true, class: 'text-[#A3A3A3] text-[14px] font-medium' })
        }
        actions.push({ type: 'icon-filled', icon: 'bx bx-show', text: 'View', function: this.viewScript.bind(this) })
      } else if (this.current_status_filter === 'Pending') {
        const buttonText = this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view ? 'Check' : 'Evaluate';
        actions.push({ type: 'button', text: buttonText, function: this.manual_check.bind(this) })
      } else if (this.current_status_filter === 'In Progress') {
        actions.push({ type: 'button', text: 'Resume', function: this.recheck.bind(this) })
      }
    }

    return actions
  }

  async manual_check(item: any) {
    try {
      let evaluation_id: number | undefined;
      if (this.is_re_evaluation_mode) {
        // HE users hit the HE start endpoint (different permission set);
        // evaluators hit the regular start.
        const is_he_user = !!this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view
          || !!this.gs?.user_role_data?.evaluations_and_revaluations_re_evaluation_head_view;
        const response = is_he_user
          ? await this.res.start_head({ script_id: item.id })
          : await this.res.start({ script_id: item.id });
        evaluation_id = response?.data?.re_evaluation_id || response?.data?.evaluation_id || response?.data?.id;
        if (!evaluation_id) {
          this.gs.toastr_shows_function(response?.message || 'Failed to start re-evaluation', 'Error', 'error');
          return;
        }
      } else {
        const params = {
          assessment_id: +this.params.assessment_id,
          user_id: this.gs.user_data.id,
          script_id: item.id,
        };
        const response = await this.es.start_ramdom_evaluation(params);
        evaluation_id = response?.data?.evaluation_id;
        if (!evaluation_id) {
          this.gs.toastr_shows_function(response?.message || 'Failed to start evaluation', 'Error', 'error');
          return;
        }
      }
      this.route.navigate(['/evalution'], { queryParams: { evaluation_id, evaluation_type: this.params.evaluation_type } });
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || error?.message || 'Failed to start evaluation', 'Error', 'error');
    }
  }
  async resume(item: any) {
    console.log(item.Evaluations);

    //  this.route.navigate(['/evalution'], { queryParams: { evaluation_id: response?.data?.id, } });
  }

  async check(item: any) {
    try {
      const response = this.is_re_evaluation_mode
        ? await this.res.start_head({ script_id: item.id })
        : await this.es.start_head_evaluation({ script_id: item.id });
      const evaluation_id = response?.data?.evaluation_id || response?.data?.id;
      if (!evaluation_id) {
        this.gs.toastr_shows_function(response?.message || 'Failed to start head evaluation', 'Error', 'error');
        return;
      }
      this.route.navigate(['/evalution'], { queryParams: { evaluation_id, evaluation_type: this.params.evaluation_type } });
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || error?.message || 'Failed to start head evaluation', 'Error', 'error');
    }
  }
  async recheckHeadEvaluation(item: any) {
    const currentUserId = this.gs.user_data.id;
    const pool = this.is_re_evaluation_mode
      ? (item.ReEvaluations || item.re_evaluations || [])
      : (item.Evaluations || []);
    // Find HE's own row (not the evaluator's last-level row which can also have head_evaluation: true)
    const headEvaluation = pool.find((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
    if (!headEvaluation) {
      this.gs.toastr_shows_function('No head evaluation found for this script', 'Error', 'error');
      return;
    }

    const he_qp: any = { evaluation_id: headEvaluation.id, evaluation_type: this.params.evaluation_type };
    if (this.is_re_evaluation_mode) he_qp.recheck = true;
    this.route.navigate(['/evalution'], { queryParams: he_qp });
  }
  async recheck(item: any) {
    try {
      const pool = this.is_re_evaluation_mode
        ? (item.ReEvaluations || item.re_evaluations || [])
        : (item.Evaluations || []);
      const evaluation = pool.length ? pool[pool.length - 1] : null;

      if (!evaluation) {
        this.gs.toastr_shows_function('No evaluation found for this script', 'Error', 'error');
        return;
      }

      const qp: any = { evaluation_id: evaluation.id, evaluation_type: this.params.evaluation_type };
      // Set recheck=true only for grace-period Re-Check (evaluation Completed).
      // Resume (evaluation In Progress) must NOT set recheck so the minimum time
      // timer continues from saved time_left instead of being skipped entirely.
      if (this.is_re_evaluation_mode && evaluation?.status === 'Completed') qp.recheck = true;
      this.route.navigate(['/evalution'], { queryParams: qp });
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }
  async viewScript(item: any) {
    const pool = this.is_re_evaluation_mode
      ? (item.ReEvaluations || item.re_evaluations || [])
      : (item.Evaluations || []);
    let evaluation: any;
    const currentUserId = this.gs.user_data.id;

    if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view
      || (this.is_re_evaluation_mode && this.gs?.user_role_data?.evaluations_and_revaluations_re_evaluation_head_view)) {
      const heRows = pool.filter((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
      // In re-evaluation mode multiple attempt rows may exist; navigate to the latest (highest id).
      evaluation = this.is_re_evaluation_mode
        ? heRows.sort((a: any, b: any) => (b.id ?? 0) - (a.id ?? 0))[0] ?? undefined
        : heRows[0];
    } else {
      const userEvals = pool.filter((e: any) => e.user_id === currentUserId);
      if (userEvals.length) {
        evaluation = userEvals.reduce((latest: any, current: any) =>
          new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest
        );
      }
      if (!evaluation) {
        evaluation = pool.find((e: any) => !e.head_evaluation || e.head_evaluation === false);
      }
    }

    if (evaluation) {
      this.route.navigate(['/evalution'], { queryParams: { evaluation_id: evaluation.id, view: true, evaluation_type: this.params.evaluation_type } });
    }
  }
  async continue(item: any) {
    this.route.navigate(['/evalution'], { queryParams: { script_id: item.id, evaluation_type: this.params.evaluation_type } });
  }
  // True when the user navigated here with ?evaluation_type=Re-Evaluation (Re-Evaluation mode).
  get is_re_evaluation_mode(): boolean {
    return String(this.params?.evaluation_type || '').toLowerCase() === 're-evaluation';
  }

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ss: ScriptService, public ar: ActivatedRoute, public vs: ValidationService, public es: EvaluationService, public res: ReEvaluationService, public ass: AssessmentService, public ds: DropdownService, private datePipe: DatePipe) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.location_name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      is_active: [true]
    });
  }
  // Camera is only required when the assessment has AI proctoring enabled — Jira-512
  get is_proctoring_enabled(): boolean {
    return this.header_details?.ai_proctoring === 'enable';
  }

  async checkCameraPermission() {
    try {
      if (!this.is_proctoring_enabled) return true;
      if (navigator.permissions?.query) {
        const status = await navigator.permissions.query({ name: 'camera' as PermissionName });
        if (status.state === 'denied') {
          this.gs.toastr_shows_function('Camera permission is required to access this page. Please enable camera access and try again.', 'Error', 'error');
          this.gs.go_back();
          return false;
        }
      }
      return true;
    } catch (error) {
      console.error('Error checking camera permission:', error);
      return true;
    }
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['evaluator']);
    let isFirstLoad = true;
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }

      // Initialize current_status_filter from query params if present
      if (params['status']) {
        this.current_status_filter = params['status'] === 'Completed' ? 'Checked' : params['status'];
      }

      // On subsequent filter changes (items already loaded), call directly
      if (!isFirstLoad) {
        this.get_script_list(this.params);
      }
      isFirstLoad = false;
    })
    await this.get_evaluation()
    await this.get_list()

    // Runs after get_list() because ai_proctoring only becomes known once the assessment is fetched
    if (!(await this.checkCameraPermission())) return;

    // Set default status if not provided in query params, now that header_details.type is available
    if (!this.params['status']) {
      if (this.is_re_evaluation_mode) {
        this.current_status_filter = 'Pending';
      } else if (!this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        this.current_status_filter = this.header_details.type?.toLowerCase() == 'auto' ? 'Checked' : 'Pending';
      } else {
        this.current_status_filter = 'Pending';
      }
    }

    await this.initializeColumns();
    // Initial load: get_list is done, items is set, now fetch scripts
    this.get_script_list(this.params)
  }

  async initializeColumns() {
    const hasHeadPermission = this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view;
    // AI Only assessments always have an AI score (it's their only score, unaffected by the
    // toggle); everything else only shows one when the assessment's AI Evaluation is enabled.
    const ai_evaluation_visible = this.header_details.ai_evaluation === 'enable' || this.items?.data?.no_of_evaluation === 'AI';

    this.columns = [
      { headerName: 'Script ID', field: 'script_id', },
      { headerName: 'Grace Period Left', filter: false, flex: 1, cellRenderer: GracePeriodCountdownComponent, cellRendererParams: { onExpired: this.onGracePeriodExpired.bind(this) } },
    ];

    if (ai_evaluation_visible) {
      // total_ai_score comes from get-script-list on both the evaluation and re-evaluation
      // branches. It is null when the script has no AI scores at all, so render a dash
      // rather than an empty cell.
      this.columns.push({
        headerName: 'AI Score',
        field: 'total_ai_score',
        valueFormatter: (params: any) => (params.value === null || params.value === undefined || params.value === '') ? '-' : params.value
      });
    }

    // Add dynamic level columns only if user has head evaluation permission
    if (hasHeadPermission && this.items?.data) {
      if (this.is_re_evaluation_mode) {
        // Re-evaluation: one evaluator pass (shown as L1) + optional HE moderation
        // on top. L1 = the non-HE re-evaluator's marks; HE marks land in the separate
        // "Head Evaluation" column added below for Completed/Checked.
        this.columns.push({
          headerName: 'L1',
          filter: true,
          flex: 1,
          valueGetter: (params: any) => this.getReEvalEvaluatorMarks(params.data)
        });
      } else if (this.items.data.no_of_evaluation !== 'AI') {
        const numberOfEvaluations = parseInt(this.items.data.no_of_evaluation) || 3;
        const highlightStyle = { backgroundColor: '#EBF2FF' };
        // Dynamically create L1, L2, L3... columns based on number_of_evaluations.
        // Highlight only the levels actually compared for variance: the last two
        // levels (evaluator vs evaluator), or L1 alone when there's a single level
        // (compared against the AI Score instead — highlighted below).
        for (let i = 1; i <= numberOfEvaluations; i++) {
          const is_compared_level = numberOfEvaluations === 1 ? i === 1 : i >= numberOfEvaluations - 1;
          this.columns.push({
            headerName: `L${i}`,
            filter: true,
            flex: 1,
            valueGetter: (params: any) => this.getEvaluationMarks(params.data, i),
            ...(is_compared_level ? { cellStyle: highlightStyle, headerStyle: highlightStyle } : {})
          });
        }
        if (numberOfEvaluations === 1) {
          const ai_score_col = this.columns.find((c: any) => c.headerName === 'AI Score');
          if (ai_score_col) {
            ai_score_col.cellStyle = highlightStyle;
            ai_score_col.headerStyle = highlightStyle;
          }
        }
        // Question-Wise Variance (%) — backend (get-script-list) computes this per script
        // whenever two comparable evaluation sources exist: single evaluator + AI Evaluation
        // enabled (L1 vs AI), or the last two completed levels (evaluator vs evaluator).
        this.columns.push({
          headerName: 'Question-Wise Variance',
          filter: false,
          flex: 1,
          valueGetter: (params: any) => this.getQuestionWiseVariance(params.data),
          cellStyle: { backgroundColor: '#3F41D11C' },
          headerStyle: { backgroundColor: '#3F41D11C' }
        });
      }
      // AI-only assessments have no evaluator levels — no columns to add here.

      if (this.current_status_filter == 'Pending' || this.current_status_filter == 'To Do') {
        this.columns.push(
          { headerName: 'Max Marks', field: 'Assessment.total_marks', filter: false, flex: 1, },
        );
      }
      if (this.current_status_filter == 'Completed' || this.current_status_filter == 'Checked') {
        // Add Head Evaluation column
        this.columns.push({
          headerName: 'Head Evaluation',
          filter: true,
          flex: 1,
          valueGetter: (params: any) => this.getHeadEvaluationMarks(params.data)
        });
      }
      this.columns.push({ headerName: 'Time Taken', field: 'time_taken', filter: true, flex: 1, valueFormatter: (p: any) => { const v = p.value; return (!v || /^0\s*(min|mins|sec|secs)(\s+0\s*(min|mins|sec|secs))*$/i.test(String(v).trim())) ? '-' : v; } });

      this.columns.push({
        headerName: 'Evaluated On',
        filter: true,
        flex: 1,
        field: 'updatedAt',
        valueFormatter: (params: any) => {
          if (this.current_status_filter === 'Pending' && this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) return '-';
          const dateVal = params.value || params.data?.updatedAt;
          return dateVal ? this.datePipe.transform(dateVal, 'dd-MM-yyyy') : '-';
        }
      });
    } else {
      // Non-HE users. Column header stays as "Obtained Marks" (unchanged), but in
      // re-eval mode pull the evaluator's own non-HE row so they always see the
      // marks they submitted — not an HE moderation row that may sit on top.
      this.columns.push({
        headerName: 'Obtained Marks',
        filter: true,
        flex: 1,
        valueGetter: (params: any) => this.is_re_evaluation_mode
          ? this.getReEvalEvaluatorMarks(params.data)
          : this.getAnyEvaluationMarks(params.data)
      });
      this.columns.push({ headerName: 'Time Taken', field: 'time_taken', filter: true, flex: 1, valueFormatter: (p: any) => { const v = p.value; return (!v || /^0\s*(min|mins|sec|secs)(\s+0\s*(min|mins|sec|secs))*$/i.test(String(v).trim())) ? '-' : v; } });
      this.columns.push({
        headerName: 'Evaluated On',
        filter: true,
        flex: 1,
        field: 'updatedAt',
        valueFormatter: (params: any) => {
          if (this.header_details.type == 'Manual') {
            if (this.current_status_filter === 'Pending' || this.current_status_filter === 'In Progress') return '-';
          }
          const dateVal = params.value || params.data?.updatedAt;
          return dateVal ? this.datePipe.transform(dateVal, 'dd-MM-yyyy') : '-';
        }
      });
    }
    // Add Actions column for both head evaluators and regular evaluators
    this.columns.push({ headerName: "Actions", sortable: false, filter: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellStyle: { 'justify-content': 'center' }, cellRendererParams: { actions: this.actions.bind(this), inline: true }, editable: false, pinned: 'right', width: 180, minWidth: 180, maxWidth: 180 });

  }

  tabList: { name: string, label?: string, action: () => void }[] = [
    { name: 'Pending', action: () => this.filter('To Do') },
    { name: 'In Progress', action: () => this.filter('IN-PROGRESS') },
    { name: 'Submitted', action: () => this.filter('SUBMITTED') },
  ];
  current_status_filter = 'Pending';
  redirect_button_text = 'Check'
  selected_faculty_id: any;
  filtered_faculty_list: any[] = [];
  view_scripts_filter: string = 'All Scripts'; // For View Scripts dropdown
  script_counts: any = { pending: 0, in_progress: 0, checked: 0 };

  // Getter to map current_status_filter to tab name
  get activeTabName(): string {
    const statusMap: { [key: string]: string } = {
      'Pending': 'Pending',
      'To Do': 'Pending',
      'In Progress': 'In Progress',
      'IN-PROGRESS': 'In Progress',
      'In-Progress': 'In Progress',
      'Checked': 'Completed',
      'Completed': 'Completed',
      'SUBMITTED': 'Submitted'
    };
    return statusMap[this.current_status_filter] || 'Pending';
  }

  filter(type: string) {
    this.current_status_filter = type;
    if (type == 'Pending' || type == 'To Do') {
      this.redirect_button_text = 'Check'
    } else if (type == 'In Progress' || type == 'IN-PROGRESS') {
      this.redirect_button_text = 'Resume'
    } else if (type == 'Checked') {
      this.redirect_button_text = 'View'
    } else {
      this.redirect_button_text = 'Re-Check'
    }
    this.initializeColumns();
    // Update params object and query params to keep them in sync
    this.params = {
      ...this.params,
      status: type,
      page: 1
    };
    this.route.navigate([], {
      queryParams: this.params,
      queryParamsHandling: 'merge'
    });
  }

  onViewScriptsChange(value: string) {
    this.view_scripts_filter = value;
    this.get_script_list({ page: 1 });
  }

  onFacultyChange(event: any) {
    this.selected_faculty_id = event.value ? event.value.value : null;
    this.params = {
      ...this.params,
      user_id: this.selected_faculty_id
    }
    this.get_list(this.params);
    this.get_script_list({ page: 1 });
  }


  async get_evaluation() {
    try {
      if (this.is_re_evaluation_mode) {
        this.evaluation = '';
        return;
      }

      let params: any = {}
      params = {
        assessment_id: this.params.assessment_id,
        user_id: this.gs.user_data.id
      }
      console.log(params, 'params');
      const res = await this.es.get_my_evaluation(params);
      if (res.message == 'No evaluation found for this assessment') {
        this.evaluation = 'Start'
      } else if (res.data) {
        this.evaluation = 'Resume'
        this.evaluation_id = res.data.evaluation_id
      }
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  async redirect_to_evaluation_page() {
    try {
      if (this.is_re_evaluation_mode) {
        const rows: any[] = (this.script as any)?.data || (this.script as any)?.rows || [];
        const in_progress_row = rows.find((s: any) => s?.re_evaluation_status === 'In Progress');
        const pending_row = rows.find((s: any) => s?.re_evaluation_status === 'Pending');
        const target = in_progress_row || pending_row;
        if (!target) {
          this.gs.toastr_shows_function(
            'No pending re-evaluations on this tab. Switch to Pending or In Progress.',
            'Info',
            'info',
          );
          return;
        }
        return this.manual_check(target);
      }

      let params: any = {}
      params = {
        assessment_id: +this.params.assessment_id,
        user_id: this.gs.user_data.id,
        level: 1,
      }
      if (this.evaluation == 'Resume') {
        this.route.navigate(['/evalution'], { queryParams: { evaluation_id: this.evaluation_id, evaluation_type: this.params.evaluation_type }, });
      } else if (this.evaluation == 'Start') {
        const res = await this.es.start_ramdom_evaluation(params);
        if (!res.data) {
          this.gs.toastr_shows_function(res.message, 'Warning', 'warning');
          return;
        }
        if (res.data.evaluation_id) {
          this.route.navigate(['/evalution'], { queryParams: { evaluation_id: res.data?.evaluation_id, evaluation_type: this.params.evaluation_type }, });
        } else {
          this.gs.toastr_shows_function(res.message, 'Error', 'error');
        }
      }
    } catch (error: any) {
      const message = error?.error?.message || error?.message || 'Failed to start evaluation';
      this.gs.toastr_shows_function(message, 'Error', 'error');
      console.error('Error in redirect_to_evaluation_page:', error);
    }
  }

  async get_list(filter?: any) {
    try {
      const res = await this.ass.get(this.params.assessment_id, { count: true, evaluation_type: this.params.evaluation_type });
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      // Load evaluators filtered by subject_id from assessment
      const subject_id = res.data?.subject_id || res.data?.Subject?.id;
      if (subject_id && this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        this.filtered_faculty_list = await this.ds.get_evaluators_by_subject(subject_id);
      }

      this.header_details.evaluated = res.data.evaluated_script
      this.header_details.total = res.data.total_script
      this.header_details.pending = res.data.pending_script
      this.header_details.checked = res.data.checked_scripts
      this.header_details.he_pending_scripts = res.data.he_pending_scripts
      this.header_details.checked_scripts = res.data.checked_scripts
      this.header_details.he_in_progress_scripts = res.data.he_in_progress_scripts
      this.header_details.type = res.data.type;
      this.header_details.in_progress_script = res.data.in_progress_script
      this.header_details.my_evaluated_script = res.data.my_evaluated_script ?? 0
      this.header_details.available_script = res.data.available_script ?? 0
      this.header_details.ai_proctoring = res.data.ai_proctoring
      this.header_details.ai_evaluation = res.data.ai_evaluation
      this.items = res;
      this.is_grace_period_active = false; // computed per-script in get_script_list

      if (this.gs.user_role_data.evaluations_and_revaluations_head_evaluation_view) {
        this.tabList = [
          { name: 'Pending', label: `Available (${this.header_details?.he_pending_scripts || 0})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.he_in_progress_scripts || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED  (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      } else {
        const available_badge = this.header_details?.type === 'Manual'
          ? (this.header_details?.available_script ?? 0)
          : (this.header_details?.pending ?? 0);
        this.tabList = [
          { name: 'Pending', label: `Available (${available_badge})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.in_progress_script || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      }
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async get_script_list(filter?: any) {
    try {
      // Map 'Checked' status to 'Completed' for backend API
      const statusForBackend = this.current_status_filter === 'Checked' ? 'Completed' : this.current_status_filter;

      const params: any = { assessment_id: this.params.assessment_id, ...filter, status: statusForBackend, dashboard: true, search: this.params.search };
      if (this.is_re_evaluation_mode) {
        params['evaluation_type'] = 'Re-Evaluation';
        // BE re-eval branch wants the evaluator/HE id to scope the result set.
        if (!this.selected_faculty_id) params['user_id'] = this.gs.user_data?.id;
      }
      if (this.selected_faculty_id) {
        params['user_id'] = this.selected_faculty_id;
      }

      // For Head Evaluators, send is_grace_period_active as false
      if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
        params['is_grace_period_active'] = false;
      }

      // Add filter for Rechecked Scripts
      if (this.view_scripts_filter === 'Rechecked Scripts') {
        params['rechecked'] = true;
      }

      const res: any = await this.ss.get_list(params);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      const isHE = this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view;
      const gracePeriod = this.items?.data?.grace_period;
      let gracePeriodMs = 0;
      if (gracePeriod) {
        const [hours, minutes, seconds] = gracePeriod.split(':').map(Number);
        gracePeriodMs = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
      }

      const isChecked = this.current_status_filter === 'Checked';

      // Add Sr.No and grace_period_end_time to each item
      res.data = (res.data || []).map((item: any, index: number) => {
        let gracePeriodEndTime = 0;       // for countdown display
        let gracePeriodFilterEndTime = 0; // for HE filter (evaluator's grace period)
        // Static label only in Checked tab
        const grace_period_display = '';

        if (gracePeriodMs > 0) {
          if (isHE) {
            const he_user_id = this.gs.user_data.id;

            // Filter value: evaluator's (non-HE) latest evaluation — used to hide script from HE while evaluator grace period is active
            const non_he_evals = item.Evaluations?.filter((e: any) => e.user_id !== he_user_id && !e.head_evaluation);
            if (non_he_evals && non_he_evals.length > 0) {
              const latest_non_he_eval = non_he_evals.sort((a: any, b: any) => b.level - a.level)[0];
              const base_time = latest_non_he_eval?.submitted_at ? new Date(latest_non_he_eval.submitted_at).getTime() : 0;
              if (base_time) gracePeriodFilterEndTime = base_time + gracePeriodMs;
            }

            // Display value (Checked tab only): HE's own head evaluation submitted_at
            if (this.current_status_filter === 'Checked') {
              const he_eval = item.Evaluations?.find((e: any) => e.head_evaluation === true && e.user_id === he_user_id);
              if (he_eval) {
                const base_time = he_eval.submitted_at ? new Date(he_eval.submitted_at).getTime() : 0;
                if (base_time) gracePeriodEndTime = base_time + gracePeriodMs;
              }
            }
          } else {
            // For regular evaluators: show timer only in Checked tab
            if (isChecked) {
              const current_user_id = this.gs.user_data.id;
              // Exclude draft evaluations — grace period should only start after submission
              const user_evaluations = item.Evaluations?.filter((e: any) => e.user_id === current_user_id && !e.is_draft);
              if (user_evaluations && user_evaluations.length > 0) {
                const latest_eval = user_evaluations.sort((a: any, b: any) => b.level - a.level)[0];
                const base_time = latest_eval?.submitted_at ? new Date(latest_eval.submitted_at).getTime() : 0;
                if (base_time) gracePeriodEndTime = base_time + gracePeriodMs;
              }
            }
          }
        }

        return {
          ...item,
          SrNo: startindex + index + 1,
          grace_period_end_time: gracePeriodEndTime,
          grace_period_filter_end_time: gracePeriodFilterEndTime,
          grace_period_display,
          grace_period_expiry: this.current_status_filter === 'Checked' ? item.grace_period_expiry : null
        };
      });

      // For HE: filter out scripts where evaluator's grace period is still active (only for To Do / In Progress)
      if (isHE && gracePeriodMs > 0 && this.current_status_filter !== 'Checked') {
        const now = Date.now();
        const visibleScripts = res.data.filter((item: any) =>
          item.grace_period_filter_end_time === 0 || now > item.grace_period_filter_end_time
        );
        this.is_grace_period_active = visibleScripts.length === 0 && res.data.length > 0;
        res.data = visibleScripts.map((item: any, index: number) => ({ ...item, SrNo: startindex + index + 1 }));
      } else {
        this.is_grace_period_active = false;
      }

      this.script = res;

      // Prefer structured counts from API (res.counts). Support multiple shapes and fallbacks.
      const c = res.counts || {};
      const pendingFromApi = c.todo ?? c.pending ?? c['to_do'] ?? res.pending_count ?? 0;
      const inProgressFromApi = c.in_progress ?? c.inprogress ?? c['in-progress'] ?? res.in_progress_count ?? 0;
      const checkedFromApi = c.checked ?? c.completed ?? res.checked_count ?? 0;

      // Initialize script_counts from available API fields
      this.script_counts = {
        pending: pendingFromApi || 0,
        in_progress: inProgressFromApi || 0,
        checked: checkedFromApi || 0
      };

      // If assessment API already returned counts earlier (this.items.data), prefer those values
      // this.items is loaded by get_list() and contains total_script, pending_script, evaluated_script, checked_scripts
      if (this.items?.data) {
        const ad = this.items.data;
        this.script_counts = {
          pending: (ad.pending_script ?? this.script_counts.pending),
          // in_progress = evaluated - checked (if that represents scripts currently in progress)
          in_progress: Math.max(0, ((ad.evaluated_script ?? 0) - (ad.checked_scripts ?? 0))),
          checked: (ad.checked_scripts ?? this.script_counts.checked)
        };
      }

      // If API returned a single "count" for this filtered request (res.count), map it to requested status
      if (typeof res.count === 'number') {
        const req = (statusForBackend || '').toString().toLowerCase();
        if (req === 'completed' || req === 'checked') {
          this.script_counts.checked = res.count;
        } else if (req === 'pending' || req === 'to do' || req === 'todo') {
          this.script_counts.pending = res.count;
        } else if (req.includes('progress')) {
          this.script_counts.in_progress = res.count;
        } else {
          this.script_counts.checked = res.count;
        }
      }

      // Build tabList labels with counts
      if (this.gs.user_role_data.evaluations_and_revaluations_head_evaluation_view) {
        this.tabList = [
          { name: 'Pending', label: `Available (${this.header_details?.he_pending_scripts || 0})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.he_in_progress_scripts || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      } else {
        const available_badge = this.header_details?.type === 'Manual'
          ? (this.header_details?.available_script ?? 0)
          : (this.header_details?.pending ?? 0);
        this.tabList = [
          { name: 'Pending', label: `Available (${available_badge})`, action: () => this.filter('Pending') },
          { name: 'In Progress', label: `IN-PROGRESS (${this.header_details?.in_progress_script || 0})`, action: () => this.filter('In Progress') },
          { name: 'Completed', label: `CHECKED (${this.header_details?.checked || 0})`, action: () => this.filter('Checked') },
        ];
      }
    } catch (error: any) {
      console.error("Error fetching scripts list:", error);
    }
  }

  getEvaluationMarks(script: any, level: number): string {

    if (!script || !script.Evaluations || !Array.isArray(script.Evaluations)) {
      return '-';
    }

    const level_evaluations = script.Evaluations.filter((e: any) => e.level === level);
    if (!level_evaluations.length) {
      return '-';
    }

    // A level can have multiple rows (a stale draft save plus the real submission,
    // or repeated re-checks) — prefer the latest completed (non-draft) one, falling
    // back to the most recent draft if the level hasn't been completed yet.
    const completed = level_evaluations.filter((e: any) => e.is_draft === false);
    const evaluation = (completed.length ? completed : level_evaluations)
      .reduce((latest: any, e: any) => (e.id > latest.id ? e : latest));

    return evaluation.total_marks?.toString() || '-';
  }

  getQuestionWiseVariance(script: any): string {
    const value = script?.question_wise_variance;
    if (value === undefined || value === null) return '-';
    return `${value}%`;
  }

  getAnyEvaluationMarks(script: any): string {
    if (!script) return '-';
    const pool: any[] = this.is_re_evaluation_mode
      ? (script.ReEvaluations || script.re_evaluations || [])
      : (script.Evaluations || []);
    if (!Array.isArray(pool) || pool.length === 0) return '-';

    // Get the latest evaluation (highest level) or first available
    const latest = pool.reduce((acc: any, current: any) => {
      return (current.level > acc.level) ? current : acc;
    }, pool[0]);

    return latest?.total_marks?.toString() || '-';
  }

  getHeadEvaluationMarks(script: any): string {
    if (!script) return '-';
    const pool: any[] = this.is_re_evaluation_mode
      ? (script.ReEvaluations || script.re_evaluations || [])
      : (script.Evaluations || []);
    if (!Array.isArray(pool)) return '-';

    const currentUserId = this.gs.user_data.id;
    const heRows = pool.filter((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
    // In re-evaluation mode multiple attempt rows exist; always take the latest (highest id).
    const headEvaluation = this.is_re_evaluation_mode
      ? heRows.sort((a: any, b: any) => (b.id ?? 0) - (a.id ?? 0))[0] ?? null
      : heRows[0] ?? null;

    if (!headEvaluation) return '-';
    return headEvaluation.total_marks?.toString() || '-';
  }

  getReEvalEvaluatorMarks(script: any): string {
    if (!script) return '-';

    // For non-HE callers: only show marks once the current attempt is Completed.
    // This prevents a previous attempt's ReEvaluation row (same or different evaluator)
    // from leaking into Pending / In Progress rows.
    const isHeCaller = !!this.gs.user_role_data?.evaluations_and_revaluations_head_evaluation_view;
    if (!isHeCaller && script.re_evaluation_status !== 'Completed') return '-';

    const pool: any[] = script.ReEvaluations || script.re_evaluations || [];
    if (!Array.isArray(pool) || pool.length === 0) return '-';

    const currentUserId = this.gs.user_data?.id;
    // HE: anchor to the currently assigned evaluator so the 2nd-attempt row is found
    //     instead of the oldest row (pool is ordered by id ASC from backend).
    // Non-HE: also take the LATEST own row so a same-evaluator 2nd attempt isn't
    //         shadowed by their 1st-attempt Completed row.
    const targetUserId = isHeCaller ? (script.assigned_evaluator_id ?? null) : currentUserId;
    const evaluatorRow = pool
      .filter((e: any) => e.head_evaluation !== true && (targetUserId != null ? e.user_id === targetUserId : true))
      .sort((a: any, b: any) => (b.id ?? 0) - (a.id ?? 0))[0] ?? null;
    if (!evaluatorRow) return '-';
    return evaluatorRow.total_marks?.toString() || '-';
  }

  isWithinGracePeriod(script: any): boolean {
    if (!script) return false;

    if (script.grace_period_expiry) {
      return Date.now() < new Date(script.grace_period_expiry).getTime();
    }

    if (!script.Evaluations || !this.items?.data) {
      return false;
    }

    const gracePeriod = this.items.data.grace_period;
    if (!gracePeriod) {
      return false;
    }

    const [hours, minutes, seconds] = gracePeriod.split(':').map(Number);
    const gracePeriodMs = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;

    let relevantEvaluation;

    if (this.gs?.user_role_data?.evaluations_and_revaluations_head_evaluation_view) {
      // For HE re-check: check their own head evaluation's createdAt (user_id check avoids picking evaluator's last-level eval)
      const currentUserId = this.gs.user_data.id;
      relevantEvaluation = script.Evaluations.find((e: any) => e.head_evaluation === true && e.user_id === currentUserId);
    } else {
      // For regular evaluator re-check: their own latest submitted (non-draft) evaluation's createdAt
      const currentUserId = this.gs.user_data.id;
      const userEvaluations = script.Evaluations.filter((e: any) => e.user_id === currentUserId && !e.is_draft);
      if (userEvaluations.length > 0) {
        relevantEvaluation = userEvaluations.reduce((latest: any, current: any) =>
          new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest
        );
      }
    }

    if (!relevantEvaluation) {
      return false;
    }

    const baseTime = relevantEvaluation.submitted_at ? new Date(relevantEvaluation.submitted_at).getTime() : 0;
    if (!baseTime) return false;

    return (Date.now() - baseTime) <= gracePeriodMs;
  }

  onGracePeriodExpired(params: any) {
    if (params && params.api && params.node) {
      setTimeout(() => {
        params.api.refreshCells({ rowNodes: [params.node], force: true });
      }, 0);
    }
  }
}
